module.exports = __webpack_public_path__ + "static/headerBg-989141d88e981b1843fe8956104afc79.png";